import { timezoneList } from '../assets/timezone';

const formatOffset = (offset: number) => {
  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset);
  const hours = Math.floor(absOffset);
  const minutes = Math.round((absOffset - hours) * 60);
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');
  return `${sign}${paddedHours}:${paddedMinutes}`;
};

export const getTime = (date: Date) => {
  const time = date.getTime();
  if (typeof time !== 'number' || !Number.isFinite(time)) return '--:--';
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const newDate = new Date(time + userTimezoneOffset);
  const h = newDate.getHours();
  const m = newDate.getMinutes();
  return `${h < 10 ? `0${h}` : `${h}`}:${m < 10 ? `0${m}` : `${m}`}`;
};

export const getTimeTzNoLess = (date: Date) => {
  const newDate = new Date(date.getTime());
  const h = newDate.getHours();
  const m = newDate.getMinutes();
  return `${h < 10 ? `0${h}` : `${h}`}:${m < 10 ? `0${m}` : `${m}`}`;
};

export async function getMyTimeZone(): Promise<string> {
  // Ensure this stays async (some callers use `.then(...)`).
  await Promise.resolve();
  const localOffset = new Date().getTimezoneOffset() / -60;
  const found = timezoneList.find((el) => el.offset === localOffset);
  if (found) return found.name;

  try {
    const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (resolved) {
      return `(GMT ${formatOffset(localOffset)}) ${resolved}`;
    }
  } catch (e) {
    console.error('Ошибка при определении таймзоны через Intl API:', e);
  }

  return '(GMT) Не удалось определить таймзону';
}

export const getTimeWithTZ = (date: Date, offset: number) => {
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const zonedDate = new Date(utc + 3600000 * offset);
  return getTime(zonedDate);
};

export const getMonday = (d: Date) => {
  const dt = new Date(d); // Create a Date instance from the input date
  const day = dt.getDay(); // Get the day of the week (0 for Sunday, 1 for Monday, and so on)
  const diff = dt.getDate() - day + (day === 0 ? -6 : 1); // Calculate the difference to Monday
  return new Date(dt.setDate(diff)); // Set the date to the calculated Monday
};

export const weekDates = (date: Date) => {
  let d = +(date || new Date());
  const days: Date[] = [];
  let i = 6;
  while (i--) {
    days.push(new Date((d += 8.64e7)));
  }
  return days;
};

export const addDateBy = (date: Date, count: number) => {
  const d = date;
  return new Date(d.setDate(d.getDate() + count));
};
export const lessDateBy = (date: Date, count: number) => {
  const d = date;
  return new Date(d.setDate(d.getDate() - count));
};

export const getDate = (date: Date, separator = '.') => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day < 10 ? `0${day}` : `${day}`}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
};

export const getDateForFilter = (date: Date) => {
  const updDate = getDate(date);
  const arr = updDate.split('.');
  return {
    start: `${arr[2]}-${arr[1]}-${arr[0]} 00:00`,
    end: `${arr[2]}-${arr[1]}-${arr[0]} 23:59`,
  };
};
